import moment, { relativeTimeRounding } from "moment";
import { TimeEvent, eventBus } from "./eventHandler";
import * as signalR from "@microsoft/signalr";

import { AthleteDTO } from "../interfaces/AthletesDTO";
import { RaceDTO } from "../interfaces/RaceDTO";
import { TimeDTO } from "../interfaces/TimeDTO";
import { NextOnStartDTO } from "../interfaces/NextonStartDTO";
import apiService from "./apiService";
import { TimingPositionsDTO } from "../interfaces/TimingPositionsDTO";
import { AthleteMiniDTO } from "../interfaces/AthleteMiniDTO";
import { ShootingLiveDTO } from "../interfaces/ShootingLiveDTO";
import { ShootingsDTO } from "../interfaces/ShootingsDTO";
import { apiURL } from "./api";
import { LevelStatusEnum } from "../interfaces/LevelsDTO";

interface MessageObject {
  Raceid: string;
  ClassID: number;
  Level: number;
  IPos: number;
  PassingTime: TimeDTO;
  Athletes: string[];
  Startno: number;
  ActiveClass?: string;
  ActiveLevel?: string;
  Athlete: AthleteDTO;
  Time: TimeDTO;
  Status: string;
  StartTime: Date;
  Lane: number;
  Sht: string;
  Data: AthleteMiniDTO;
  Shootnr: number;
  Missed: number;
  ShootingData: ShootingLiveDTO;
  Shooting: ShootingsDTO;
}
interface ShootingMessage {
  Raceid: string;
  Lane: string;
  Status: string;
}
interface SignalRScroll {
  TimeMS: number;
  Type: string;
  Message: MessageObject; // Using 'any' for 'object' from C#, you might want to specify a more precise type if possible
  Parameter1: string;
  CountID: number;
}

interface QueuedDataType {
  Message?: MessageObject | null;
  Time?: TimeDTO | null;
  Athlete?: AthleteDTO | null;
  Type: string;
  CountID: number;
}
class EventOperations {
  public exitStatus: string[] = ["DNS", "DNF", "DSQ"];
  public eventData: RaceDTO;
  private connection: signalR.HubConnection | null;
  private lastId: number = 0;
  private updateFromWS: boolean = true;
  private QueuedData: { [key: number]: QueuedDataType };
  private timer: any;
  private reconnectionTry: number = 0;
  private manualDisconnect: boolean = false;
  public activeClass: number | null = null;
  public activeLevel: number | null = null;
  public TimeScroll: { [key: number]: TimeDTO } = {};

  
constructor(eventData: RaceDTO) {
  this.eventData = eventData;
  this.lastId = eventData.LastTimeID;
  this.connection = this.createHubConnection();

  this.timer = setInterval(() => {
    this.checkConnection();
  }, 5000);
  this.setupListeners();
  this.fixIntermediates();

  this.QueuedData = {};
  window.addEventListener('online', () => this.handleOnline());
  window.addEventListener('offline', () => this.handleOffline());

}

private handleOnline() {
  console.log("Network connected, attempting to reconnect...");
  this.checkConnection(); // Attempt to reconnect when the network is back
}

private handleOffline() {
  console.log("Network disconnected. Will retry when network is back.");
}

private createHubConnection(): signalR.HubConnection | null {
  let _connection;
  try{
    _connection = new signalR.HubConnectionBuilder()
    .withUrl(apiURL + "myhub")
    .build();
  }
  catch (err){
    _connection = null;
  }
  if (_connection == null){
    return null;
  }
  

  _connection.onclose(async (error) => {
    if (error) {
      console.error("Connection closed with error:", error);
    } else {
      console.log("Connection closed.");
    }
  
    // Implement any additional logic if needed (e.g., notifying the user)
    await this.handleReconnect();
});

  return _connection;
}


private async checkConnection() {

  //console.log(navigator.onLine,this.connection, this.connection ? this.connection.state : null);
  //if (!this.connection || this.connection.state === signalR.HubConnectionState.Disconnected) {
  if (navigator.onLine && (!this.connection || this.connection.state !== signalR.HubConnectionState.Connected)) {
   console.log("online");
    await this.handleReconnect();
  }
}

private async handleReconnect() {
  console.log("Attempting to reconnect...");
  let attempt = 0;

  //while (this.connection.state !== signalR.HubConnectionState.Connected) {
    attempt += 1;
    const delay = this.calculateReconnectDelay(attempt);
    console.log(`Reconnection attempt ${attempt}: retrying in ${delay}ms`);
    await new Promise(resolve => setTimeout(resolve, delay));

    if (!this.connection) {
      this.connection = this.createHubConnection();
    }
    if (!this.connection){
      return;
    }
    try {
      // await this.connection.start();
      console.log("SignalR Connected.");
      
 this.startConnection();
this.setupListeners();
      attempt = 0; // Resetting the counter after successful connection
    } catch (err) {
      console.error("SignalR Connection Error:", err);
    }
  //}
}


private calculateReconnectDelay(attempt: number): number {
  // Exponential backoff strategy with a max delay of 30 seconds
  return 0;
  //return Math.min(30000, (Math.pow(2, attempt) - 1) * 1000);
}
private setupListeners(): void {
  if (!this.connection) return;

  this.connection.on("passingScroll", (ipo, Json, cou) => {
    const obj: MessageObject = JSON.parse(Json);
    this.ControlId(cou);
    if (this.updateFromWS) {
      this.addTime(obj.ClassID, obj.Level, ipo, obj.PassingTime);
    } else {
      this.QueuedData[cou] = {
        Time: obj.PassingTime,
        Type: "passingScroll",
        CountID: cou,
      };
    }
  });
  this.connection.on("deleteTime", (Json, cou) => {
    const obj: MessageObject = JSON.parse(Json);
    this.ControlId(cou);
    if (this.updateFromWS) {
      this.deleteTime(obj.ClassID, obj.Level, obj.IPos, obj.Startno);
    } else {
      this.QueuedData[cou] = {
        Message: obj,
        Type: "deleteTime",
        CountID: cou,
      };
    }
  });
  this.connection.on("addAthlete", (Json, cou) => {
    const obj: AthleteDTO = JSON.parse(Json);
    this.ControlId(cou);
    if (this.updateFromWS) {
      this.addAthlete(obj);
    } else {
      this.QueuedData[cou] = {
        Athlete: obj,
        Type: "addAthlete",
        CountID: cou,
      };
    }
  });
  this.connection.on("addStarttime", (Json, cou) => {
    const obj: AthleteDTO = JSON.parse(Json);
    this.ControlId(cou);
    if (this.updateFromWS) {
      this.setStarttime(obj.ClassID, obj.Level, obj.Startno, obj.StartTime);
    } else {
      this.QueuedData[cou] = {
        Athlete: obj,
        Type: "addStarttime",
        CountID: cou,
      };
    }
  });
  this.connection.on("addActive", (Json, cou) => {
    const obj: MessageObject = JSON.parse(Json);
    this.ControlId(cou);
    if (this.updateFromWS) {
      this.setActive(obj.ClassID, obj.ActiveLevel);
    } else {
      this.QueuedData[cou] = {
        Athlete: null,
        Type: "addActive",
        CountID: cou,
        Message: obj,
      };
    }
  });
  this.connection.on("nextStart", (Json, cou) => {
    const obj: NextOnStartDTO = JSON.parse(Json);
    this.ControlId(cou);
  });
  this.connection.on("setStarttime", (Json, cou) => {
    const obj: MessageObject = JSON.parse(Json);
    this.ControlId(cou);
    if (this.updateFromWS) {
      this.setStarttime(obj.ClassID, obj.Level, obj.Startno, obj.StartTime);
    } else {
      this.QueuedData[cou] = {
        Message: obj,
        Type: "setStarttime",
        CountID: cou,
      };
    }
  });
  this.connection.on("addStatus", (Json, cou) => {
    const obj: MessageObject = JSON.parse(Json);

    this.ControlId(cou);
    if (this.updateFromWS) {
      this.setStatus(obj.ClassID, obj.Level, obj.Startno, obj.Status);
    } else {
      this.QueuedData[cou] = {
        Message: obj,
        Type: "addStatus",
        CountID: cou,
      };
    }
  });
  this.connection.on("shootLive", (Json, cou) => {
    const obj: MessageObject = JSON.parse(Json);
    this.ControlId(cou);
    if (this.updateFromWS) {
      this.setShootLive(
        obj.ClassID,
        obj.Level,
        obj.Startno,
        obj.ShootingData
      );
      //this.setStarttime(obj.ClassID,obj.Level,obj.Startno,obj.StartTime);
    } else {
      this.QueuedData[cou] = {
        Message: obj,
        Type: "shootLive",
        CountID: cou,
      };
    }
  });
  this.connection.on("addShooting", (Json, cou) => {
    const obj: MessageObject = JSON.parse(Json);
    this.ControlId(cou);
    if (this.updateFromWS) {
      this.setShooting(obj.ClassID, obj.Level, obj.Startno, obj.Shooting);
      //this.setStarttime(obj.ClassID,obj.Level,obj.Startno,obj.StartTime);
    } else {
      this.QueuedData[cou] = {
        Message: obj,
        Type: "addShooting",
        CountID: cou,
      };
    }
  });
  this.connection.on("deleteShooting", (Json, cou) => {
    const obj: MessageObject = JSON.parse(Json);
    this.ControlId(cou);
    if (this.updateFromWS) {
      this.setDeleteShooting(
        obj.ClassID,
        obj.Level,
        obj.Startno,
        obj.Shootnr
      );
    } else {
      this.QueuedData[cou] = {
        Message: obj,
        Type: "deleteShooting",
        CountID: cou,
      };
    }
  });
  this.connection.on("shootStatus", (Json, cou) => {
    const obj: MessageObject = JSON.parse(Json);
    this.ControlId(cou);
    if (this.updateFromWS) {
      this.setShootStatus(
        obj.ClassID,
        obj.Level,
        obj.Startno,
        obj.Lane,
        obj.Status
      );
    } else {
      this.QueuedData[cou] = {
        Message: obj,
        Type: "shootStatus",
        CountID: cou,
      };
    }
  });

  this.connection.onclose(() => {
    if (this.manualDisconnect) {
      console.log("Manually disconnected, won't try to reconnect");
      this.manualDisconnect = false; // Reset the flag for future connections
    } else {
     
      // setTimeout(() => {
      //   if (!this.connection){
      //     return;
      //    }
      //   console.log("Disconnected");
      //   this.connection.start().then(() => {
      //     console.log("Reconnected");
      //     this.connection!
      //       .invoke("joinGroup", this.eventData.Id)
      //       .catch((error) => {
      //         console.error("Error invoking joinGroup:", error);
      //         setTimeout(() => {
      //           this.stopConnection();
      //           // this.startConnection();
      //         }, 1000);
      //         setTimeout(() => {
      //           // this.stopConnection();
      //           this.startConnection();
      //         }, 2500);
      //       });
      //   });
      // }, 3000);
    }
  });
}

startConnection(): void {
  if (!this.connection || !navigator.onLine) return;
  try {
    this.connection
    .start()
    .then(() => {
      console.log("Connected to group " + this.eventData.Id);
      this.connection!.invoke("joinGroup", this.eventData.Id.toString()); // Assume server-side method
    })
    .catch((err) => console.log("Could not connect:", err));
  }
  catch (err){
    console.log(err);
  }
  
}

stopConnection(): void {
  if (this.connection){
    this.manualDisconnect = true;
    this.connection.stop();
  }
  
}

  
  private fixIntermediates() {
    for (let kc in this.eventData.Class) {
      for (let kl in this.eventData.Class[kc].Level) {
        let Tposes = this.eventData.Class[kc].Level[kl].TimePos;
        for (let a in this.eventData.Class[kc].Level[kl].Athletes) {
          let ath = this.eventData.Class[kc].Level[kl].Athletes[a];
          ath.IposRankSortOrder = {};
          for (let kt in Tposes) {
            if (kt == "0") {
              continue;
            }
            ath.IposRankSortOrder[parseInt(kt)] = {
              order: 0,
              timetobeat: null,
              timetopass: null,
            };
          }
        }

        for (let kt in Tposes) {
          if (kt == "0") {
            continue;
          }
          for (let at in this.eventData.Class[kc].Level[kl].Athletes) {
            // Tposes.filter(o => o.AthleteID == )
            let athl = this.eventData.Class[kc].Level[kl].Athletes[at];

            // athl.IposRankSortOrder[kt] = null;
            let tims: TimeDTO[] = Object.values(Tposes[kt].TimePass).filter(
              (entry) => entry.AthleteID === athl.ID
            );
            if (tims.length > 0 && parseInt(kt) < 1000) {
              athl.Times[parseInt(kt)] = tims[0];
              this.TimeScroll[tims[0].ID] = tims[0];
            }
          }

          let tPre: TimingPositionsDTO | null = Tposes[kt].PreTime;
          if (tPre) {
            if (tPre.Ipos in Tposes) {
              Tposes[tPre.Ipos].IposToIntermediate = Tposes[kt].Ipos;
            }
            this.reRank(parseInt(kc), parseInt(kl), parseInt(kt), tPre.Ipos);
          } else {
            this.reRank(parseInt(kc), parseInt(kl), parseInt(kt), null);
          }
        }
      }
    }
  }

  

  private ControlId(newId: number): void {
    if (this.lastId === -1) {
      this.lastId = newId;
    } else if (this.lastId !== newId - 1) {
      this.updateFromWS = false;
      console.log(
        `Sorry nu har vi tappat ett id, senaste ID: ${this.lastId} vi borde vara på: ${newId}`
      );
      this.lastId = newId;
      this.ReadFromMissedTimeID();
    } else {
      this.lastId = newId;
    }
  }
  private ReadFromMissedTimeID(): void {
    let queryUrl = `/GetDataFromLastSignalR/${this.eventData.Id}/?FromId=${
      this.lastId
    }&ApiKey=${"#apikey#"}`;
    // AjaxHandler(queryUrl, AddSignalRCompareData);

    const fetchData = async () => {
      try {
        const result = await apiService.get<SignalRScroll[]>(queryUrl);
        // console.log(JSON.stringify(result));
        this.AddSignalRCompareData(result);
        //  setRaceData(new EventOperations(result));
      } catch (error) {
        console.error("Error fetching data", error);
        this.updateFromWS = true;
      }
    };
    fetchData();
  }
  private AddSignalRCompareData(data: SignalRScroll[]): void {
    for (let i = 0; i < data.length; i++) {
      let da = data[i];
      this.InsertQueuedData_Scroll(da);
    }
    if (Object.keys(this.QueuedData).length > 0) {
      while (Object.keys(this.QueuedData).length > 0) {
        let da = Object.values(this.QueuedData)[0];
        this.InsertQueuedData_Cached(da);
        delete this.QueuedData[parseInt(Object.keys(this.QueuedData)[0])];
      }
    }
    this.updateFromWS = true;
    // return data;
  }
  private InsertQueuedData_Cached(data: QueuedDataType): void {
    // console.log(data);
    let Obj = data.Message;
    if (Obj == null) {
      return;
    }

    switch (data.Type) {
      case "passingScroll":
        this.addTime(
          Obj.Time.ClassID, // ["Time"]["ClassID"],
          Obj.Time.Level,
          Obj.Time.Ipos, //["Time"]["IPos"],
          Obj.Time
        );
        break;
      case "deleteTime":
        this.deleteTime(Obj.ClassID, Obj.Level, Obj.IPos, Obj.Startno);
        break;
      case "addAthlete":
        this.addAthlete(Obj.Athlete);
        break;
      case "addStarttime":
        this.setStarttime(Obj.ClassID, Obj.Level, Obj.Startno, Obj.StartTime);
        break;
      case "addActive":
        this.setActive(Obj.ClassID, Obj.ActiveLevel);
        break;
      case "addStatus":
        this.setStatus(Obj.ClassID, Obj.Level, Obj.Startno, Obj.Status);
        break;
      case "addShooting":
        this.setShooting(Obj.ClassID, Obj.Level, Obj.Startno, Obj.Shooting);
        break;
      case "shootStatus":
        this.setShootStatus(
          Obj.ClassID,
          Obj.Level,
          Obj.Startno,
          Obj.Lane,
          Obj.Status
        );
        break;
      case "shootLive":
        this.setShootLive(
          Obj.ClassID,
          Obj.Level,
          Obj.ShootingData.Startno,
          Obj.ShootingData
        );
        break;
      case "deleteShooting":
        this.setDeleteShooting(
          Obj.ClassID,
          Obj.Level,
          Obj.Startno,
          Obj.Shootnr
        );
        break;
      default:
        break;
    }
    this.lastId = data.CountID;
    // console.log(data);
  }
  private InsertQueuedData_Scroll(data: SignalRScroll): void {
    // console.log(data);
    let Obj: MessageObject | any = data.Message;
    //let at:AthleteDTO | null = null;

    switch (data.Type) {
      case "passingScroll":
        this.addTime(Obj.ClassID, Obj.Level, Obj.IPos, Obj.PassingTime);
        break;
      case "deleteTime":
        this.deleteTime(Obj.ClassID, Obj.Level, Obj.IPos, Obj.Startno);
        break;
      case "addAthlete":
        this.addAthlete(Obj);
        break;
      case "addStatus":
        this.setStatus(Obj.ClassID, Obj.Level, Obj.Startno, Obj.Status);
        break;
      case "addStarttime":
        this.setStarttime(Obj.ClassID, Obj.Level, Obj.Startno, Obj.StartTime);
        break;
      case "addActive":
        this.setActive(Obj.ClassID, Obj.ActiveLevel);
        break;
      case "addShooting":
        this.setShooting(Obj.ClassID, Obj.Level, Obj.Startno, Obj.Shooting);
        break;
      case "shootStatus":
        this.setShootStatus(
          Obj.ClassID,
          Obj.Level,
          Obj.Startno,
          Obj.Lane,
          Obj.Status
        );
        break;
      case "shootLive":
        this.setShootLive(Obj.ClassID, Obj.Level, Obj.Startno, Obj.Data);
        break;
      case "deleteShooting":
        this.setDeleteShooting(
          Obj.ClassID,
          Obj.Level,
          Obj.Startno,
          Obj.Shootnr
        );
        break;
      default:
        break;
    }
    this.lastId = data.CountID;
    // console.log(data);
  }

  private parseTimeToMoment(time: string): moment.Moment {
    return moment(time, "HH:mm:ss.SSS");
  }
  public addTime(
    _class: number,
    _level: number,
    _ipos: number,
    _tobject: TimeDTO
  ): void {
    if (
      !this.checkIfIposAndAthletesExists(
        _class,
        _level,
        _ipos,
        _tobject.Startno
      )
    ) {
      return;
    }
    const Tpass =
      this.eventData.Class[_class].Level[_level].TimePos[_ipos].TimePass;
    let updated = false;
    let _athobject: AthleteDTO;
    if (
      _tobject.Startno in this.eventData.Class[_class].Level[_level].Athletes
    ) {
      _athobject =
        this.eventData.Class[_class].Level[_level].Athletes[_tobject.Startno];
    } else {
      console.log("Athlete not found");
      return;
    }

    if (
      _athobject.Startno in this.eventData.Class[_class].Level[_level].Athletes
    ) {
      this.eventData.Class[_class].Level[_level].Athletes[
        _athobject.Startno
      ].Status = _athobject.Status;
    } else {
      this.eventData.Class[_class].Level[_level].Athletes[_athobject.Startno] =
        _athobject;
    }

    this.eventData.Class[_class].Level[_level].Athletes[
      _athobject.Startno
    ].Times[_ipos] = _tobject;
    for (let i = 0; i < Tpass.length; i++) {
      if (_tobject.AthleteID === Tpass[i].AthleteID) {
        Tpass[i] = _tobject;
        updated = true;
        break;
      }
    }
    if (!updated) {
      Tpass.push(_tobject);
    }
    if (_tobject.Ipos < 1000) {
      this.TimeScroll[_tobject.ID] = _tobject;
      eventBus.emit(`tim_new`, _tobject);
    }

    // console.log(timStat);
    // console.log(`tim_${_class}_${_level}_${_ipos}_${_athobject.Startno}`);
    // eventBus.emit(
    //   `tim_${_class}_${_level}_${_ipos}_${_athobject.Startno}`,
    //   timStat
    // );
    let timePre =
      this.eventData.Class[_class].Level[_level].TimePos[_ipos].PreTime; //Här hämtar vi

    this.reRank(_class, _level, _ipos, timePre == null ? null : timePre.Ipos);

    let timeToPre =
      this.eventData.Class[_class].Level[_level].TimePos[_ipos]
        .IposToIntermediate;

    if (timeToPre) {
      this.reRank(_class, _level, timeToPre, _ipos);
    }
  }
  private reRank(
    _class: number,
    _level: number,
    _ipos: number,
    _preIpos: number | null
  ): void {
    let lastTime = "";
    let lastRank = -1;
    let leadTime: any;
    let preTimed: TimeDTO[] | null = null;
    let updateTimes: TimeEvent[] = [];
    let RankList: TimeDTO[] = [];
    const locRes = this.eventData.Class[_class].Level[_level].TimePos[
      _ipos
    ].TimePass.sort(
      (a, b) =>
        this.parseTimeToMoment(a.RunTime).valueOf() -
        this.parseTimeToMoment(b.RunTime).valueOf()
    );
    let TposPre =
      this.eventData.Class[_class].Level[_level].TimePos[_ipos].PreTime;
    if (TposPre) {
      preTimed = this.getOnlyPretimedList(locRes, _class, _level, TposPre.Ipos);
    }
    //Vi hämtar ut ledartiden för att räkna ut difftider
    if (locRes.length > 0) {
      leadTime = this.parseTimeToMoment(locRes[0].RunTime);
    }
    //Här rankar vi om det hela och lägger till åkare om det saknas en
    locRes.forEach((res, i) => {
      const diff =
        this.parseTimeToMoment(res.RunTime).valueOf() - leadTime.valueOf();
      let updateRow: boolean = false;
      let newDiff: string = moment(diff).utc().format("HH:mm:ss.SSS");
      let newRank: number = lastTime === res.RunTime ? lastRank : i + 1;
      res.DiffClass = newDiff;
      res.RankClass = newRank;
      res.RankPreTiming = newRank;
      lastRank = res.RankClass;
      lastTime = res.RunTime;
      if (RankList.length > 0) {
        RankList.push(res);
      } else {
        RankList = new Array(1);
        RankList[0] = res;
      }
    });

    //Hämtar ut de som enbart är pretimead
    if (preTimed && preTimed.length > 0) {    
      //Om preipos finsn
      if (_preIpos) {
        //preTimed //innehåller de premtimead
        let PreRanks: TimeDTO[] =
          this.eventData.Class[_class].Level[_level].TimePos[_preIpos].TimePass;

        let i = 0;
        //Vi kör igenom hela ranklist för att hitta datan
        while (i < RankList.length) {
          let preTime = PreRanks.filter(
            (o) => o.AthleteID === RankList[i].AthleteID
          );
          let add = false;
          let comapredRuntime = RankList[i].RunTime;
          if (preTime.length > 0) {
            let pret = preTimed.filter(
              (o) => o.RankClass < preTime[0].RankClass
            );
            pret.map((obj, index) => {
              let selSortOrder =
                this.eventData.Class[_class].Level[_level].Athletes[obj.Startno]
                  .IposRankSortOrder;
              selSortOrder[_ipos]!.timetobeat = comapredRuntime;
              RankList.splice(i + index, 0, obj);

              preTimed = preTimed!.filter((o) => o.AthleteID !== obj.AthleteID);
              // i++;
              add = true;
            });
            if (!add) {
              i++;
            }
          } else {
            i++;
          }
        }
        if (preTimed.length > 0) {
          let iv = 0;
          while (iv < preTimed.length) {
            RankList.push(preTimed[iv]);

            let selSortOrder =
              this.eventData.Class[_class].Level[_level].Athletes[
                preTimed[iv].Startno
              ].IposRankSortOrder;
            selSortOrder[_ipos]!.timetobeat = null;
            // preTimed.splice(0,1);
            iv++;
          }
        }

        let SOrder = 0;
        let lastRanked = 0;
        
        RankList.map((rn, index) => {
          let selSortOrder =
            this.eventData.Class[_class].Level[_level].Athletes[rn.Startno]
              .IposRankSortOrder;
          SOrder++;
          let fixedSortorder = SOrder;

          // if (selSortOrder[_ipos] === null || selSortOrder[_ipos] !== SOrder) {
          if (
            this.exitStatus.indexOf(
              this.eventData.Class[_class].Level[_level].Athletes[rn.Startno]
                .Status
            ) > -1
          ) {
            fixedSortorder = SOrder + 10000;
          }

          selSortOrder[_ipos]!.order = fixedSortorder;
          // selSortOrder[_ipos]!.timetobeat = null;

          let NextTimeToBeat: string | null = null;
          //Vi kollar om åkaren är på pretimen eller vid mellantiden
          if (_preIpos === rn.Ipos) {
            let timedtoToBeat = locRes.filter((o) => o.RankClass > lastRanked);
            if (timedtoToBeat.length > 0) {
              NextTimeToBeat = timedtoToBeat[0].RunTime;
              rn.RunTimeTobeat = timedtoToBeat[0].RunTime;
              selSortOrder[_ipos]!.timetobeat = timedtoToBeat[0].RunTime;
            }
            else{
            }
            
          } else {
            //Lastranked
            lastRanked = rn.RankClass;
          }
          if (selSortOrder[_ipos]) {
            // selSortOrder[_ipos]!.order = SOrder;
            selSortOrder[_ipos]!.timetobeat = NextTimeToBeat;
          } else {           
            selSortOrder[_ipos] = {
              order: fixedSortorder,
              timetobeat: NextTimeToBeat,
              timetopass: null,
            };
          }
        
          
          updateTimes = this.GetTimeEventArray(
            "add" + (_preIpos === rn.Ipos ? "Pre" : ""),
            rn,
            rn.Startno,
            fixedSortorder,
            NextTimeToBeat,
            updateTimes
          );
          // }
        });
      }
    } else {
      let SOrder = 0;
      locRes.map((rn) => {
        let selSortOrder =
          this.eventData.Class[_class].Level[_level].Athletes[rn.Startno]
            .IposRankSortOrder;
        // console.log(selSortOrder);
        // if (selSortOrder[_ipos] === null || selSortOrder[_ipos] !== SOrder) {
        let fixedSortorder = SOrder;
        if (
          this.exitStatus.indexOf(
            this.eventData.Class[_class].Level[_level].Athletes[rn.Startno]
              .Status
          ) > -1
        ) {
          fixedSortorder = SOrder + 10000;
        }
        
        selSortOrder[_ipos]!.order = fixedSortorder;
        selSortOrder[_ipos]!.timetobeat = null;

        updateTimes = this.GetTimeEventArray(
          "add" + (_preIpos === rn.Ipos ? "Pre" : ""),
          rn,
          rn.Startno,
          fixedSortorder,
          null,
          updateTimes
        );
        // }
        SOrder++;
      });
    }
    // let startCalc = moment();
    this.calculateArrivalTime(_class, _level, _ipos);
    // if (_ipos < 999){
    //  let nIpos:number = this.findIposAfter(this.eventData.Class[_class].Level[_level].TimePos[_ipos], _ipos);
    // //  console.log(nIpos);
    //   this.calculateArrivalTime(_class, _level, nIpos);
    // }

    // let diff = moment().diff(startCalc);

    // console.log(diff);

    for (let i = 0; i < updateTimes.length; i++) {
      eventBus.emit(
        `tim_${_class}_${_level}_${_ipos}_${updateTimes[i].startno!}`,
        updateTimes[i]
      );
    }
    if (_ipos === 999) {
      // console.log(RankList);
    }
  }
  private GetTimeEventArray(
    type: string,
    time: TimeDTO,
    startno: number,
    sortorder: number,
    runtTimeTobeat: string | null,
    timeEventArray: TimeEvent[]
  ): TimeEvent[] {
    // let vt = timeEventArray.filter((o) => o.startno == startno);

    let timEv: TimeEvent = {
      messageType: type,
      time: time,
      startno: startno,
      order: sortorder,
      runtTimeTobeat: runtTimeTobeat,
    };
    // if (vt.length > 0) {
    //   vt[0] = timEv;
    //   return timeEventArray;
    // }
    if (timeEventArray.length > 0) {
      timeEventArray.push(timEv);
    } else {
      timeEventArray = new Array(1);
      timeEventArray[0] = timEv;
    }
    return timeEventArray;
  }

  private calculateArrivalTime(
    classID: number,
    level: number,
    ipos: number
  ): void {
    if (ipos >= 999) return;
    const timePos = this.eventData.Class[classID].Level[level].TimePos;
    const iposPass = timePos[ipos] ?? null;
    const iposBefore = timePos[ipos - 1] ?? null;
    let iposAfter = timePos[ipos + 1] ?? this.findIposAfter(timePos, ipos); // Extracted logic to a separate method
    if (ipos == 1) {
      // console.log("IPos is noll");
    }
    if (iposAfter === null || iposPass === null) {
      // console.log(classID, level, ipos);
      return;
    }

    let distBefore: number; // = iposPass.Distance - iposBefore.Distance;
    if (iposBefore) {
      distBefore = iposPass.Distance - iposBefore.Distance;
    } else {
      distBefore = iposPass.Distance;
    }
    const distAfter = iposAfter.Distance - iposPass.Distance;

    let tPasses = iposPass.TimePass.filter((o) =>
      this.athletePresentInTimePasses(o.AthleteID, iposBefore, iposAfter)
    );

    tPasses.forEach((obj, ind) => {
      const timArray = this.getTimeArrayAroundIndex(tPasses, ind);
      // console.log(timArray);
      let procDiffBetween2 = this.calculateProcDiff(
        timArray,
        iposBefore,
        iposPass,
        iposAfter,
        distBefore,
        distAfter
      );

      if (procDiffBetween2.length > 4) {
        procDiffBetween2 = this.removeMaxMin(procDiffBetween2);
      }

      const kmTime = this.calculateKmTime(
        obj,
        iposBefore,
        iposPass,
        procDiffBetween2,
        distBefore,
        distAfter
      ); // Extracted logic to a separate method
      if (kmTime !== -1) {
        this.updateAthleteTime(
          iposAfter,
          classID,
          level,
          obj,
          kmTime,
          distAfter
        ); // Extracted logic to a separate method
      }
    });
  }

  private findIposAfter(timePos: any, ipos: number): number {
    const keys = Object.keys(timePos)
      .map(Number)
      .filter((key) => key < 999);
    const maxKeyUnder999 = Math.max(...keys);
    return maxKeyUnder999 === ipos + 1
      ? timePos[maxKeyUnder999]
      : timePos[999] || null;
  }

  private calculateKmTime(
    obj: TimeDTO,
    iposBefore: TimingPositionsDTO,
    iposPass: TimingPositionsDTO,
    procDiffBetween: number[],
    distBefore: number,
    distAfter: number
  ): number {
    let kmTime: number = -1;
    let averageProc =
      procDiffBetween.reduce((acc, curr) => acc + curr, 0) /
      procDiffBetween.length;
    let athBef = iposBefore
      ? iposBefore.TimePass.filter((o) => o.AthleteID === obj.AthleteID)
      : null;
    let athCur = iposPass.TimePass.filter((o) => o.AthleteID === obj.AthleteID);
    if (averageProc < 0) {
      averageProc = averageProc + 1;
    }
    if (athBef === null && athCur.length > 0) {
      let athDiff = moment.duration(athCur[0].RunTime).asMilliseconds() / 1000;
      if (procDiffBetween.length > 0) {
        kmTime = athDiff / distBefore;
        kmTime = kmTime + kmTime * averageProc;
      } else {
        kmTime = athDiff / distBefore;
      }
    } else if (athBef === null) {
      console.log("null value");
    } else if (athBef.length > 0 && athCur.length > 0) {
      let athDiff =
        this.getTimeBetweenPoints(athCur[0].RunTime, athBef[0].RunTime) / 1000;
      if (procDiffBetween.length > 0) {
        kmTime = athDiff / distBefore;
        kmTime = kmTime + kmTime * averageProc;
      } else {
        kmTime = athDiff / distBefore;
      }
    }
    return kmTime;
  }

  private updateAthleteTime(
    iposAfter: any,
    classID: number,
    level: number,
    obj: any,
    kmTime: number,
    distAfter: number
  ): void {
    // let calculatedTime = moment(obj.PassingTime).add(
    //   kmTime * distAfter,
    //   "seconds"
    // );
    let calculatedTime = moment(obj.RunTime, "HH:mm:ss.SSSSSSS").add(
      kmTime * distAfter,
      "seconds"
    );

    let Aths = Object.values(
      this.eventData.Class[classID].Level[level].Athletes
    ).filter((o) => o.ID === obj.AthleteID);
    if (Aths.length > 0) {
      let StTIm = Aths[0].UsedStartTime
        ? moment(Aths[0].UsedStartTime)
        : moment(Aths[0].StartTime);

        // console.log(Aths[0].Startno,iposAfter.Ipos,Aths[0].IposRankSortOrder[iposAfter.Ipos]);
      let ipRank = Aths[0].IposRankSortOrder[iposAfter.Ipos] ?? {
        order: 0,
        timetobeat: null,
        timetopass: null,
      };
      // const stTimDuration = moment.duration(StTIm.diff(moment("1970-01-01")));
      ipRank.timetopass = calculatedTime.format("HH:mm:ss.S");
      // console.log(Aths[0].Startno,Aths[0]);
    }
  }

  private athletePresentInTimePasses(
    athleteID: number,
    iposBefore: TimingPositionsDTO | null,
    iposAfter: TimingPositionsDTO
  ): boolean {
    if (iposBefore) {
      return (
        iposBefore.TimePass.some((o) => o.AthleteID === athleteID) 
      );
    } else {
      return iposAfter.TimePass.some((o) => o.AthleteID === athleteID);
    }
  }

  private getTimeArrayAroundIndex(tPasses: TimeDTO[], ind: number): TimeDTO[] {
    return [
      ...tPasses.slice(Math.max(ind - 3, 0), ind),
      ...tPasses.slice(ind + 1, ind + 4),
    ];
  }

  private calculateProcDiff(
    timArray: TimeDTO[],
    iposBefore: TimingPositionsDTO | null,
    iposPass: TimingPositionsDTO,
    iposAfter: TimingPositionsDTO,
    distBefore: number,
    distAfter: number
  ): number[] {
    let procDiffBetween: number[] = [];
    timArray.forEach((tims) => {
      const timeP = tims.RunTime;
      const timeB = iposBefore
        ? this.getTimeFromAthleteID(tims.AthleteID, iposBefore.TimePass)
        : null;
      const timeA = this.getTimeFromAthleteID(
        tims.AthleteID,
        iposAfter.TimePass
      );
      if (timeB !== undefined && timeA !== undefined) {
        let msB; // = this.getTimeBetweenPoints(timeP, timeB.RunTime) / distBefore;
        if (timeB === null) {
          msB = moment(timeP, "HH:mm:ss.SSSSSSS").valueOf();
        } else {
          msB = this.getTimeBetweenPoints(timeP, timeB.RunTime) / distBefore;
        }
        const msA = this.getTimeBetweenPoints(timeA.RunTime, timeP) / distAfter;
        procDiffBetween.push((msA - msB) / msB);
      }
    });
    return procDiffBetween;
  }

  private getTimeFromAthleteID(
    athleteID: number,
    timePass: TimeDTO[]
  ): TimeDTO | undefined {
    return timePass.find((o) => o.AthleteID === athleteID); // Assuming TimeDTO is a class, adjust accordingly
  }

  // Other methods remain unchanged

  private getTimeBetweenPoints(firstTime: string, time: string): number {
    const time1 = moment(firstTime, "HH:mm:ss.SSSSSSS");
    const time2 = moment(time, "HH:mm:ss.SSSSSSS");

    const duration = moment.duration(time1.diff(time2));
    return duration.asMilliseconds();
  }
  private removeMaxMin(arr: number[]): number[] {
    if (arr.length <= 2) return [];

    const max = Math.max(...arr);
    const min = Math.min(...arr);

    return arr.filter((num) => num !== max && num !== min);
  }

  public deleteTime(
    _class: number,
    _level: number,
    _ipos: number,
    _strn: number
  ): void {
    if (!this.checkIfIposAndAthletesExists(_class, _level, _ipos, _strn)) {
      return;
    }
    const Tpass =
      this.eventData.Class[_class].Level[_level].TimePos[_ipos].TimePass;

    if (
      _ipos in this.eventData.Class[_class].Level[_level].Athletes[_strn].Times
    ) {
      const timId =
        this.eventData.Class[_class].Level[_level].Athletes[_strn].Times[_ipos]
          .ID;

      if (timId in this.TimeScroll) {
        delete this.TimeScroll[timId];
        eventBus.emit(`tim_new`, timId);
      }

      delete this.eventData.Class[_class].Level[_level].Athletes[_strn].Times[
        _ipos
      ];
      this.eventData.Class[_class].Level[_level].TimePos[_ipos].TimePass =
        this.eventData.Class[_class].Level[_level].TimePos[
          _ipos
        ].TimePass.filter((o) => o.Startno !== _strn);
    }

    let timStat: TimeEvent = {
      messageType: "delete",
      time: null,
      order: null,
      runtTimeTobeat: null,
    };

    eventBus.emit(`tim_${_class}_${_level}_${_ipos}_${_strn}`, timStat);
    let timePoses = this.eventData.Class[_class].Level[_level].TimePos;

    //För att radera tiden från pretimen också
    Object.keys(timePoses).map((key) => {
      if (timePoses[parseInt(key)].PreTime) {
        if (timePoses[parseInt(key)].PreTime?.Ipos == _ipos) {
          let timStat2: TimeEvent = {
            messageType: "deletePre",
            time: null,
            order: null,
            runtTimeTobeat: null,
          };
          eventBus.emit(
            `tim_${_class}_${_level}_${key}_${_strn}`,
            timStat2
          );
        }
      }
    });
    //Slut på radera pretime

    this.reRank(
      _class,
      _level,
      _ipos,
      this.eventData.Class[_class].Level[_level].TimePos[_ipos].PreTime!.Ipos
    );
  }

  public addAthlete(_athlete: AthleteDTO): void {
    if (!this.checkIfLevelExists(_athlete.ClassID, _athlete.Level)) {
      return;
    }
    if (
      this.checkIfAthletesExists(
        _athlete.ClassID,
        _athlete.Level,
        _athlete.Startno
      )
    ) {
      return;
    }
    _athlete.IposRankSortOrder = {};
    _athlete.Times = {};
    if (_athlete.ClassID in this.eventData.Class) {
      if (_athlete.Level in this.eventData.Class[_athlete.ClassID].Level) {
        let Tpos =
          this.eventData.Class[_athlete.ClassID].Level[_athlete.Level].TimePos;
        for (let key in Tpos) {
          _athlete.IposRankSortOrder[key] = {
            order: 0,
            timetobeat: null,
            timetopass: null,
          };
        }
        this.eventData.Class[_athlete.ClassID].Level[_athlete.Level].Athletes[
          _athlete.Startno
        ] = _athlete;
        eventBus.emit(`athlete_add`, _athlete);
      }
    }
  }

  public setStarttime(
    classId: number,
    level: number,
    startno: number,
    starttime: Date
  ): void {
    this.eventData.Class[classId].Level[level].Athletes[startno].UsedStartTime =
      starttime;
    let timStat: TimeEvent = {
      messageType: "changedstarttime",
      status: null,
      order: null,
      runtTimeTobeat: null,
      timeInDate: starttime,
    };
    if (!this.checkIfAthletesExists(classId, level, startno)) {
      return;
    }
    eventBus.emit(`tim_${classId}_${level}_0_${startno}`, timStat);
    // eventBus.emit(`tim_${classId}_${level}_999_${status}`, timStat);
    // eventBus.emit(`at_${_athlete.ClassID}_${_athlete.Level}`,this.eventData.Class[_athlete.ClassID].Level[_athlete.Level].Athletes);
  }
  private setActive(classId: number, level: string | undefined): void {
    if (level === undefined) {
      eventBus.emit("active_level", classId, 0);
    } else {
      eventBus.emit(`lvl_status_${classId}_${level}`, LevelStatusEnum.Running);
      this.eventData.Class[classId].Level[parseInt(level)].Status =
        LevelStatusEnum.Running;

      eventBus.emit("active_level", classId, parseInt(level));
    }
  }

  //this.setStatus(Obj["ClassID"], Obj["Level"], Obj["Startno"], Obj["Status"]);

  public setStatus(
    classId: number,
    level: number,
    startno: number,
    status: string
  ): void {
    // console.log(classId, level, startno, status);
    if (status == "TVFollow") {
      if (startno === -1) {
        eventBus.emit(`tvfollow`, null);
      } else {
        if (!this.checkIfAthletesExists(classId, level, startno)) {
          return;
        }
        eventBus.emit(
          `tvfollow`,
          this.eventData.Class[classId].Level[level].Athletes[startno]
        );
      }
      return;
    }
    if (status === "LEVELOK") {
      this.eventData.Class[classId].Level[level].Status =
        LevelStatusEnum.ResultConfirmed;
      eventBus.emit(
        `lvl_status_${classId}_${level}`,
        LevelStatusEnum.ResultConfirmed
      );
      return;
    }
    if (!this.checkIfAthletesExists(classId, level, startno)) {
      return;
    }
    this.eventData.Class[classId].Level[level].Athletes[startno].Status =
      status;
    let timStat: TimeEvent = {
      messageType: "changedstatus",
      status: status,
      order: null,
      runtTimeTobeat: null,
    };
    eventBus.emit(`tim_${classId}_${level}_0_${status}`, timStat);
    eventBus.emit(`tim_${classId}_${level}_999_${status}`, timStat);
    eventBus.emit(`at_status_${classId}_${level}_${startno}`, status);
  }
  public setShootLive(
    classId: number,
    level: number,
    startno: number,
    data: ShootingLiveDTO
  ): void {
    if (data === undefined) {
      return;
    }
    if (!this.checkIfAthletesExists(classId, level, startno)) {
      return;
    }
    if (Object.keys(data).some((arg) => arg === "Lane") === undefined) {
      return;
    }
    if (data.Lane === null) {
      return;
    }
    this.eventData.ShootingRange[data.Lane] = data;
    let ath = this.eventData.Class[classId].Level[level].Athletes[startno];
    let timStat: TimeEvent = {
      messageType: "shootLive",
      order: null,
      runtTimeTobeat: null,
      shooting: data,
    };
    eventBus.emit(`shooting_${data.Lane}`, timStat);
    // eventBus.emit(`tim_${classId}_${level}_999_${status}`, timStat);
    // eventBus.emit(`at_${_athlete.ClassID}_${_athlete.Level}`,this.eventData.Class[_athlete.ClassID].Level[_athlete.Level].Athletes);
  }
  public setShootStatus(
    classId: number,
    level: number,
    startno: number,
    lane: number,
    status: string
  ): void {
    // this.eventData.ShootingRange[data.Lane] = data;
    // let ath = this.eventData.Class[classId].Level[level].Athletes[startno];
    if (status == "OUT") {
      this.eventData.ShootingRange[lane] = null;
    }

    let timStat: TimeEvent = {
      messageType: "shootStatus",
      order: null,
      runtTimeTobeat: null,
      status: status,
    };
    eventBus.emit(`shooting_${lane}`, timStat);
    // eventBus.emit(`shooting_status_${data.Lane}`, { timStat, data, ath });
    // eventBus.emit(`tim_${classId}_${level}_999_${status}`, timStat);
    // eventBus.emit(`at_${_athlete.ClassID}_${_athlete.Level}`,this.eventData.Class[_athlete.ClassID].Level[_athlete.Level].Athletes);
  }
  public setShooting(
    classId: number,
    level: number,
    startno: number,
    shooting: ShootingsDTO
  ): void {
    let ath = this.eventData.Class[classId].Level[level].Athletes[startno];
    ath.Shooting[shooting.ShootNr] = shooting;

    // let timStat: TimeEvent = {
    //   messageType: "shootFired",
    //   order: null,
    //   runtTimeTobeat: null,
    // };
    eventBus.emit(`shooting_changed_${classId}_${level}_${startno}`, shooting);
    // eventBus.emit(`tim_${classId}_${level}_999_${status}`, timStat);
    // eventBus.emit(`at_${_athlete.ClassID}_${_athlete.Level}`,this.eventData.Class[_athlete.ClassID].Level[_athlete.Level].Athletes);
  }
  public setDeleteShooting(
    classId: number,
    level: number,
    startno: number,
    shootingnr: number
  ): void {
    if (
      this.eventData &&
      this.eventData.Class &&
      this.eventData.Class[classId] &&
      this.eventData.Class[classId].Level &&
      this.eventData.Class[classId].Level[level] &&
      this.eventData.Class[classId].Level[level].Athletes &&
      this.eventData.Class[classId].Level[level].Athletes[startno] &&
      this.eventData.Class[classId].Level[level].Athletes[startno].Shooting
    ) {
      delete this.eventData.Class[classId].Level[level].Athletes[startno]
        .Shooting[shootingnr];
    }
    let timStat: TimeEvent = {
      messageType: "shootDeleted",
      order: shootingnr,
      runtTimeTobeat: null,
    };
    eventBus.emit(`shooting_changed_${classId}_${level}_${startno}`, null);
    // eventBus.emit(`tim_${classId}_${level}_999_${status}`, timStat);
    // eventBus.emit(`at_${_athlete.ClassID}_${_athlete.Level}`,this.eventData.Class[_athlete.ClassID].Level[_athlete.Level].Athletes);
  }
  private getOnlyPretimedList(
    _rlist: TimeDTO[],
    classid: number,
    level: number,
    preIpos: number
  ): TimeDTO[] {
    if (preIpos < 1) {
      return [];
    }
    if (!(preIpos in this.eventData.Class[classid].Level[level].TimePos)) {
      return [];
    }

    let PreWarned: TimeDTO[] =
      this.eventData.Class[classid].Level[level].TimePos[preIpos].TimePass;
    let NotPassedIntermediate: TimeDTO[] = [];
    for (let key in PreWarned) {
      if (!_rlist.some((e) => e.Startno === PreWarned[key].Startno)) {
        let copiedTime = JSON.parse(JSON.stringify(PreWarned[key]));
        copiedTime.Lane = 1;
        NotPassedIntermediate.push(copiedTime);
      }
    }
    return NotPassedIntermediate;
  }
  public checkIfRaceIDExists(raceID: number): boolean {
    return this.eventData && this.eventData.Id === raceID;
  }

  public checkIfClassIDExists(classID: number): boolean {
    return classID in this.eventData.Class;
  }

  public checkIfLevelExists(classID: number, Level: number): boolean {
    return (
      this.checkIfClassIDExists(classID) &&
      Level in this.eventData.Class[classID].Level
    );
  }

  public checkIfIposExists(
    classID: number,
    Level: number,
    Ipos: number
  ): boolean {
    return (
      this.checkIfLevelExists(classID, Level) &&
      Ipos in this.eventData.Class[classID].Level[Level].TimePos
    );
  }

  public checkIfAthletesExists(
    classID: number,
    Level: number,
    Startno: number
  ): boolean {
    return (
      this.checkIfLevelExists(classID, Level) &&
      Startno in this.eventData.Class[classID].Level[Level].Athletes
    );
  }

  public checkIfIposAndAthletesExists(
    classID: number,
    Level: number,
    Ipos: number,
    Startno: number
  ): boolean {
    return (
      this.checkIfIposExists(classID, Level, Ipos) &&
      this.checkIfAthletesExists(classID, Level, Startno)
    );
  }
}

export default EventOperations;
